import { render, staticRenderFns } from "./StaffItem.vue?vue&type=template&id=45578776"
import script from "./StaffItem.vue?vue&type=script&lang=js"
export * from "./StaffItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports